import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";

const styles = () => ({
  popper: {
    top: "-20px !important"
  },
  tooltip: {
    backgroundColor: "#005AA9"
  }
});

const StyledTooltip = props => {
  const { classes, content, notToShow, children } = props;

  return (
    <Tooltip
      TransitionComponent={Zoom}
      title={content}
      disableHoverListener={notToShow}
      enterDelay={300}
      classes={{
        popper: classes.popper,
        tooltip: classes.tooltip
      }}
      style={{ left: "100px !important" }}
    >
      {children}
    </Tooltip>
  );
};

export default withStyles(styles)(StyledTooltip);
